import lazyScreen from '../utils/lazyScreen';
const B2BSupplierPartners = lazyScreen(() => import('../pages/b2b/B2BSupplierPartners/index.js'), 'pages/b2b/B2BSupplierPartners/index.js');
const B2BSupplierPartner = lazyScreen(() => import('../pages/b2b/B2BSupplierPartner/index.js'), 'pages/b2b/B2BSupplierPartner/index.js');
const B2BSupplierOrders = lazyScreen(() => import('../pages/b2b/B2BSupplierOrders/index.js'), 'pages/b2b/B2BSupplierOrders/index.js');
const B2BSupplierOrder = lazyScreen(() => import('../pages/b2b/B2BSupplierOrder/index.js'), 'pages/b2b/B2BSupplierOrder/index.js');
const B2BCatalogs = lazyScreen(() => import('../pages/b2b/B2BCatalogs/index.js'), 'pages/b2b/B2BCatalogs/index.js');
const B2BCatalog = lazyScreen(() => import('../pages/b2b/B2BCatalog/index.js'), 'pages/b2b/B2BCatalog/index.js');
const B2BBuyerPartners = lazyScreen(() => import('../pages/b2b/B2BBuyerPartners/index.js'), 'pages/b2b/B2BBuyerPartners/index.js');
const B2BBuyerPartner = lazyScreen(() => import('../pages/b2b/B2BBuyerPartner/index.js'), 'pages/b2b/B2BBuyerPartner/index.js');
const B2BBuyerOrders = lazyScreen(() => import('../pages/b2b/B2BBuyerOrders/index.js'), 'pages/b2b/B2BBuyerOrders/index.js');
const B2BBuyerOrder = lazyScreen(() => import('../pages/b2b/B2BBuyerOrder/index.js'), 'pages/b2b/B2BBuyerOrder/index.js');
const B2BItemMappings = lazyScreen(() => import('../pages/b2b/B2BItemMappings/index.js'), 'pages/b2b/B2BItemMappings/index.js');

export default [
    // Supplier (Công ty — quản lý nhượng quyền)
    { path: '/b2b/B2BSupplierPartners', component: B2BSupplierPartners },
    { path: '/b2b/B2BSupplierPartner/:code', component: B2BSupplierPartner },
    { path: '/b2b/B2BSupplierOrders', component: B2BSupplierOrders },
    { path: '/b2b/B2BSupplierOrder/:code', component: B2BSupplierOrder },
    { path: '/b2b/B2BCatalogs', component: B2BCatalogs },
    { path: '/b2b/B2BCatalog/:code', component: B2BCatalog },

    // Buyer (Cửa hàng — đặt hàng NCC)
    { path: '/b2b/B2BBuyerPartners', component: B2BBuyerPartners },
    { path: '/b2b/B2BBuyerPartner/:code', component: B2BBuyerPartner },
    { path: '/b2b/B2BBuyerOrders', component: B2BBuyerOrders },
    { path: '/b2b/B2BBuyerOrder/:code', component: B2BBuyerOrder },
    { path: '/b2b/B2BItemMappings', component: B2BItemMappings }
];
